import type { OperatingHoursRange } from '~~/layers/core/api/shared/@types/generated/backend/graphql-schema-types'

import {
  DefaultTeasersDocument,
  RecommendationsDocument,
  TeasersDocument,
} from '#api/app/composables/backend.generated'

const ONE_HOUR_MS = 60 * 60 * 1000

export const useHighFrequencyTeaserRefetch = (
  operating: boolean | undefined,
  operatingHours: OperatingHoursRange | null | undefined,
) => {
  if (!operatingHours) return

  const now = Date.now()
  const targetTime = operating
    ? new Date(operatingHours.nextEndInclusive).getTime() + 1000
    : new Date(operatingHours.nextStart).getTime()

  const delay = targetTime - now
  if (delay <= 0 || delay > ONE_HOUR_MS) return

  const apolloClient = useNuxtApp().$apollo.defaultClient

  const timer = setTimeout(() => {
    apolloClient.refetchQueries({
      include: [TeasersDocument, DefaultTeasersDocument, RecommendationsDocument],
    })
  }, delay)

  onUnmounted(() => clearTimeout(timer))
}
